import React, {Component} from 'react';
import apiclient from 'lib/apiclient';
import useAreas from 'hooks/useAreas';
import useSalesCoordinators from 'hooks/useSalesCoordinators';
import useSupportCoordinators from 'hooks/useSupportCoordinators';
import { Button } from 'reactstrap';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import { query } from 'js-query-builder';
import { useHistory, useLocation } from 'react-router-dom';

function getThisMonth()
{
  const today = new Date();
  return {year:today.getFullYear(), month:today.getMonth()+1};
}

function getLastMonth()
{
  return getPrevMonth(getThisMonth());
}

function getNextMonth(value)
{
  if (value.month === 12) {
    return {year:value.year + 1, month:1};
  }
  else {
    return {year:value.year, month:value.month + 1}
  }
}

function getPrevMonth(value)
{
  if (value.month === 1) {
    return {year:value.year - 1, month:12};
  }
  else {
    return {year:value.year, month:value.month - 1}
  }
}

const Table = (data,targetMonth) => {
  const history = useHistory();
  const location = useLocation();
  return (
    <table className='table table-striped' aria-labelledby="tabelLabel">
      <thead>
        <tr>
          <th>ID</th>
          <th>管理番号</th>
          <th>企業名</th>
          <th>営業</th>
          <th>サポート</th>
          <th>回数</th>
        </tr>
      </thead>
      <tbody>
        {data.map(item =>
          <tr key={item.customerId} onClick={() => history.push(`${location.pathname}/${targetMonth}/${item.customerId}`)}>
            <td>{item.customerId}</td>
            <td>{item.managementNumber}</td>
            <td>{item.customerName}</td>
            <td>{item.salesCoordinatorName}</td>
            <td>{item.supportCoordinatorName}</td>
            <td>{item.amount}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default () => {
  const [data, setData] = React.useState({});
  const [targetMonth, setTargetMonth] = React.useState(getLastMonth());
  const [areaFilter, setAreaFilter] = React.useState('');
  const areas = useAreas();
  const [salesCoordinatorFilter, setSalesCoordinatorFilter] = React.useState('');
  const salesCoordinators = useSalesCoordinators();
  const [supportCoordinatorFilter, setSupportCoordinatorFilter] = React.useState('');
  const supportCoordinators = useSupportCoordinators();
  const [freetrial, setFreeTrial] = React.useState(false);
  const [demo, setDemo] = React.useState(false);

  React.useEffect(() => {
    setData({ loaded: false });
    apiclient.get(
      query(`api/sales/${targetMonth.year}-${targetMonth.month}`)
        .param('area', areaFilter)
        .param('sales', salesCoordinatorFilter)
        .param('support', supportCoordinatorFilter)
        .param('freetrial', freetrial ? 'true' : 'false')
        .param('demo', demo ? 'true' : 'false')
        .build())
      .then(response => {
       setData({ list: response.data, loaded: true });
          });
  }, [targetMonth, areaFilter, salesCoordinatorFilter, supportCoordinatorFilter, freetrial, demo]);

  const handleDownload = React.useCallback(() => {
    apiclient.download(
      query(`api/sales/csv/${targetMonth.year}-${targetMonth.month}`)
        .param('area', areaFilter)
        .param('sales', salesCoordinatorFilter)
        .param('support', supportCoordinatorFilter)
        .param('freetrial', freetrial ? 'true' : 'false')
        .param('demo', demo ? 'true' : 'false')
        .build());
  }, [targetMonth, areaFilter, salesCoordinatorFilter, supportCoordinatorFilter, freetrial, demo]);

  const contents = data.loaded ? Table(data.list, `${targetMonth.year}-${targetMonth.month}`) : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" >売上一覧</h1>
        <h2>
          <Button onClick={() => setTargetMonth(getPrevMonth(targetMonth))}>&#12296;</Button>
          <span style={{marginLeft:'20px'}}>{targetMonth.year}</span>
          <span> - </span>
          <span style={{marginRight:'20px', display:'inline-block', width:'30px', textAlign:'center'}}>{targetMonth.month}</span>
          <Button onClick={() => setTargetMonth(getNextMonth(targetMonth))}>&#12297;</Button>
        </h2>
        <Form>
          <FormGroup>
            <Label>エリア</Label>
            <Input type="select" id="area" value={areaFilter} onChange={e => setAreaFilter(e.target.value)}>
              <option value="">(ALL)</option>
              {areas.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
            </Input>
            <Label>営業担当者</Label>
            <Input type="select" id="area" value={salesCoordinatorFilter} onChange={e => setSalesCoordinatorFilter(e.target.value)}>
              <option value="">(ALL)</option>
              {salesCoordinators.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
            </Input>
            <Label>サポート担当者</Label>
            <Input type="select" id="area" value={supportCoordinatorFilter} onChange={e => setSupportCoordinatorFilter(e.target.value)}>
              <option value="">(ALL)</option>
              {supportCoordinators.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
            </Input>
          </FormGroup>
          <FormGroup check>
            <Label check><Input type="checkbox" id="isFreeTrial" checked={freetrial} onChange={e => setFreeTrial(e.target.checked)} />{' '}体験版</Label>
          </FormGroup>
          <FormGroup check>
            <Label check><Input type="checkbox" id="isDemo" checked={demo} onChange={e => setDemo(e.target.checked)} />{' '}デモ版</Label>
          </FormGroup>
        </Form>
        <h2>
          <Button onClick={handleDownload}>CSVダウンロード</Button>
        </h2>
       {contents}
      </div>
    );
}